import { useMemo } from 'react'
import DOMPurify from 'dompurify'

type SafeHtmlProps = {
  html: string
  allowedTags?: string[]
  allowedAttrs?: string[]
  className?: string
  disableLinks?: boolean
}

export function SafeHtml({
  html,
  allowedTags = ['b', 'br'],
  allowedAttrs = [],
  className,
  disableLinks = false,
}: SafeHtmlProps) {
  const sanitizedHtml = useMemo(() => {
    // Filter out 'a' tag if links are disabled
    const finalAllowedTags = disableLinks ? allowedTags.filter(tag => tag !== 'a') : allowedTags

    // Add target and rel to links before sanitizing
    let processedHtml = html
    if (!disableLinks && finalAllowedTags.includes('a')) {
      processedHtml = html.replace(
        /<a\s+([^>]*?)href=["']([^"']*?)["']([^>]*?)>/gi,
        (match, before, href, after) => {
          if (href.startsWith('http://') || href.startsWith('https://')) {
            return `<a ${before}href="${href}"${after} target="_blank" rel="noopener noreferrer">`
          }
          return match
        },
      )
    }

    return DOMPurify.sanitize(processedHtml, {
      ALLOWED_TAGS: finalAllowedTags,
      ALLOWED_ATTR: [...allowedAttrs, 'target', 'rel'],
    })
  }, [html, allowedTags, allowedAttrs, disableLinks])

  return <div className={className} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
}
